import { Col, Container, Form, Row } from "react-bootstrap";

const Component = () => {
  const logoPath = `${process.env.PUBLIC_URL}/Fugro-Logo-RGB-WH.png`;
  return (
    <Container>
      <Row>
        <Col xl={7}>
          <img
            style={{ display: "inline-block" }}
            src={logoPath}
            alt="Fugro Logo"
            height="45px"
          />
          <Form.Label
            style={{
              display: "inline-block",
              fontWeight: "bold",
              fontSize: "1.2em",
            }}>
            LPM report generator
          </Form.Label>
          <small style={{ fontSize: "0.6em" }} className="mx-5">
            updated at: {process.env.REACT_APP_BUILD_TIME}
          </small>
        </Col>
        <Col xl={5} className="text-end">
          <small>
            © {new Date().getFullYear()} Powered by Virgil HO and Jasper NGAN
          </small>
          <br />
          <small>If you have any question, please contact Virgil HO.</small>
          <br />
        </Col>
      </Row>
    </Container>
  );
};

export default Component;
